import { render, staticRenderFns } from "./EvaluationExamDefinitionSelectbox.vue?vue&type=template&id=7022a3c9"
import script from "./EvaluationExamDefinitionSelectbox.vue?vue&type=script&lang=js"
export * from "./EvaluationExamDefinitionSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports